import { useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { Professional } from '../../../interface/interface';
import { Button } from 'primereact/button';
import { Icon } from '@iconify/react';
import './ProfileDataView.scss';
import { loadWebAppointmentsUrl } from '../../../servicesHooks/DigitalRP/useDigitalRPService';
import { Toast } from 'primereact/toast';

const ProfileDataView = ({ profileData, edit, setActiveView, setSubActiveView, prevActiveView, setPrevActiveView, prevSubActiveView, setPrevSubActiveView }: { profileData: Professional|undefined, edit:() => void, setActiveView: (av: number|undefined) => void, setSubActiveView: (sav: number|undefined) => void, prevActiveView: number|undefined, setPrevActiveView: (pav: number|undefined) => void, prevSubActiveView: number|undefined, setPrevSubActiveView: (psav: number|undefined) => void }) => {
    const intl = useIntl();
    const toast = useRef(null)

    const [isMobile, setisMobile] = useState(window.innerWidth < 700)
    const [webAppointmentsUrl, setWebAppointmentsUrl] = useState<string>('')

    const showMessage = (msg: any, ref: React.RefObject<Toast>) => {
        ref.current?.show({ summary: msg, life: 3000 });
    };

    useEffect(() => {
        const loadProfessionalsOfSecretary = async () => {
            const urlWebappointments:string = await loadWebAppointmentsUrl();
            setWebAppointmentsUrl(urlWebappointments)
        };

        loadProfessionalsOfSecretary();
        
        const handleResize = () => {
            setisMobile(window.innerWidth < 700);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleCopyLink = () => {
        navigator.clipboard.writeText(webAppointmentsUrl).then(() => {
          showMessage('Enlace copiado al portapapeles', toast)
        }).catch(err => {
          console.error('Error al copiar el enlace: ', err);
        });
    };

    const handleGoBack = () => {
        setSubActiveView(prevSubActiveView)
        setPrevSubActiveView(undefined)
        setActiveView(prevActiveView)
        setPrevActiveView(undefined)
    }
    
    if (!profileData) return "No data";

    if (isMobile)
        return (
            <div className="profile-data-view" style={{ padding: '15px' }}>
                <div style={{marginLeft: '-15px'}}>
                    <Button className='btnCancel' label={'◄ '+intl.formatMessage({ id: "Back" })} 
                        onClick={handleGoBack} />
                </div>
        
                <h1 style={{ fontWeight: 600 }}>Datos de perfil</h1>
                
                <div style={{ marginTop: '15px' }}>
                    <div style={{fontSize:'13px'}}>
                        <div style={{ marginBottom: '15px', display:'flex', justifyContent:'space-between' }}>
                            
                            <label style={{ fontSize: '16px', fontWeight: 600 }}>{profileData.firstname+" "+profileData.lastname}</label>
                            
                            <Button 
                                style={{ background: 'none', border: 'none', padding:'0px', borderRadius:'20px' }}
                                onClick={() => edit()}
                            >
                                <i className="pi pi-pen-to-square" style={{ color:'#01717C', fontSize: '18px', padding: '8px', backgroundColor: '#ECECEC', borderRadius: '100%' }}></i>
                            </Button>

                        </div>

                        <div style={{ marginBottom: '5px' }}>
                            <span className='span-black'>{profileData.specialitiesList?.length > 1 ? "Especialidades":"Especialidad"}</span>
                            <p className='p-600'>{profileData.specialitiesList.map(speciality => speciality.name).join(', ')}</p>
                        </div>

                        <div style={{ marginBottom: '5px' }}>
                            <span className='span-black'>Matrícula</span>
                            <p className='p-600'>{profileData.workenrollmenttype} {profileData.workenrollment}</p>
                        </div>

                        <div style={{ marginBottom: '5px' }}>
                            <span className='span-black'>DNI</span>
                            <p className='p-600'>{profileData.document}</p>
                        </div>

                        {/*<div style={{ marginBottom: '5px' }}>
                            <span className='span-black'>Selfie con DNI</span>
                            <img src={profileData.imagewithdocument} alt="Selfie con DNI" style={{ padding: '8px' }} />
                        </div>*/}

                        <div style={{ marginBottom: '5px' }}>
                            <span className='span-black'>Mail</span>
                            <p className='p-600'>{profileData.email}</p>
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <span className='span-black'>Cel</span>
                            <p className='p-600'>{profileData.mobilephone}</p>
                        </div>
                    </div>

                    <div style={{boxShadow: '0 4px 4px rgba(0,0,0,0.15)'}} className="collapsible-card">
                        <div className='content-header'>
                            <div className="header">
                                <div style={{color:'#B27668', fontSize:'14px'}} className="title">LUGAR DE ATENCIÓN</div>
                            </div>
                        </div>
                        <div className="content">
                            <div className='span-black' style={{fontSize:'13px', fontWeight:600, display:'flex', flexDirection:'column'}}>
                                <span>{profileData.attentionplace?.name}</span>
                                <span style={{marginTop:'9px', fontWeight:400}}>Dirección</span>
                                <span>{profileData.attentionplace?.address+" - "+profileData.attentionplace?.city}</span>
                                <span style={{marginTop:'9px', fontWeight:400}}>Web o redes sociales</span>
                                <span>{profileData.attentionplace?.websiteorsocialmedia}</span>
                                <div><img className='ml-4' src={profileData.attentionplace?.logo} alt="LogoImg" style={{ padding: '8px'}}/></div>
                            </div>
                        </div>
                    </div>

                    {/*<Button
                        className='w-full configuration-button'
                        label="Cambiar contraseña"
                        style={{ marginBottom: '15px' }}
                        onClick={() => {}}
                    />*/}
                    <Button
                        className='w-full configuration-button'
                        label="Tu dominio"
                        style={{ marginBottom: '15px' }}
                        onClick={() => {}}
                    >
                        <Icon icon='bi:globe' style={{ color: '#3CB8BA' }} />
                    </Button>
                    <Button
                        className='w-full configuration-button'
                        label="Link para solicitud de recetas"
                        onClick={handleCopyLink}
                        >
                        <i className="pi pi-copy" style={{ color: '#3CB8BA' }}/>
                    </Button>
                </div>
                <Toast ref={toast} position='bottom-left'/>
            </div>
        );
    else
        return (
            <div className="profile-data-view" style={{ padding: '15px' }}>
                <div style={{marginLeft: '-15px'}}>
                    <Button className='btnCancel' label={'◄ '+intl.formatMessage({ id: "Back" })} 
                        onClick={handleGoBack} />
                </div>
        
                <h1 style={{ fontWeight: 600 }}>Datos de perfil</h1>

                <div style={{ marginBottom: '15px', display:'flex', justifyContent:'space-between', padding: '0 15px' }}>
                            
                    <label style={{ fontSize: '16px', fontWeight: 600, paddingTop: '5px' }}>{profileData.firstname+" "+profileData.lastname}</label>
                    
                    <Button 
                        style={{ background: 'none', border: 'none', padding:'0px', borderRadius:'20px' }}
                        onClick={() => edit()}
                    >
                        <i className="pi pi-pen-to-square" style={{ color:'#01717C', fontSize: '18px', padding: '8px', backgroundColor: '#ECECEC', borderRadius: '100%' }}></i>
                    </Button>

                </div>

                <div style={{ display: 'flex', gap: '20px', padding: '15px' }}>
                    <div style={{ flex: 1 }}>
                        <div style={{ boxShadow: '0 4px 4px rgba(0,0,0,0.15)', marginBottom: '20px' }} className="collapsible-card">
                            <div className='content-header'>
                                <div className="header">
                                    <div style={{ color: '#B27668' }} className="title">DATOS PROFESIONALES</div>
                                </div>
                            </div>
                            <div className="content">
                                <div style={{ fontSize: '13px', fontWeight: 600 }}>
                                    <span style={{fontWeight:400}}>{profileData.specialitiesList?.length > 1 ? "Especialidades":"Especialidad"}</span>
                                    <p style={{ marginBottom: '9px' }}>
                                        {profileData.specialitiesList.map(speciality => speciality.name).join(', ')}
                                    </p>
                                    <span style={{marginTop:'9px', fontWeight:400}}>Matrícula</span>
                                    <p>{profileData.workenrollmenttype} {profileData.workenrollment}</p>
                                </div>
                            </div>
                        </div>

                        <div style={{boxShadow: '0 4px 4px rgba(0,0,0,0.15)'}} className="collapsible-card">
                            <div className='content-header'>
                                <div className="header">
                                    <div style={{color:'#B27668', fontSize:'14px'}} className="title">LUGAR DE ATENCIÓN</div>
                                </div>
                            </div>
                            <div className="content">
                                <div className='span-black' style={{fontSize:'13px', fontWeight:600, display:'flex', flexDirection:'column'}}>
                                    <span>{profileData.attentionplace?.name}</span>
                                    <span style={{marginTop:'9px', fontWeight:400}}>Dirección</span>
                                    <span>{profileData.attentionplace?.address+" - "+profileData.attentionplace?.city}</span>
                                    <span style={{marginTop:'9px', fontWeight:400}}>Web o redes sociales</span>
                                    <span>{profileData.attentionplace?.websiteorsocialmedia}</span>
                                    <div><img className='ml-4' src={profileData.attentionplace?.logo} alt="LogoImg" style={{ padding: '8px'}}/></div>
                                </div>
                            </div>
                        </div>

                        <Button
                            className='w-full configuration-button'
                            label="Tu dominio"
                            style={{ marginBottom: '15px' }}
                            onClick={() => {}}
                        >
                            <Icon icon='bi:globe' style={{ color: '#3CB8BA' }} />
                        </Button>
                        <Button
                            className='w-full configuration-button'
                            label="Link para solicitud de recetas"
                            onClick={handleCopyLink}
                        >
                            <i className="pi pi-copy" style={{ color: '#3CB8BA' }} />
                        </Button>
                    </div>

                    <div style={{ flex: 1 }}>
                        <div style={{ boxShadow: '0 4px 4px rgba(0,0,0,0.15)', marginBottom: '20px' }} className="collapsible-card">
                            <div className='content-header'>
                                <div className="header">
                                    <div style={{ color: '#B27668' }} className="title">DATOS PERSONALES</div>
                                </div>
                            </div>
                            <div className="content">
                                <div style={{ fontSize: '13px', fontWeight: 600 }}>
                                    <span style={{fontWeight:400}}>Sexo</span>
                                    <p style={{marginBottom:'9px'}}>{profileData.gender === 'M'? 'Masculino' : 'Femenino'}</p>
                                    <span style={{fontWeight:400}}>DNI</span>
                                    <p style={{marginBottom:'9px'}}>{profileData.document}</p>
                                    <span style={{fontWeight:400}}>Mail</span>
                                    <p style={{marginBottom:'9px'}}>{profileData.email}</p>
                                    <span style={{fontWeight:400}}>Cel</span>
                                    <p style={{marginBottom:'9px'}}>{profileData.mobilephone}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Toast ref={toast} position='top-right' style={{backgroundColor: 'white'}}/>
            </div>
        );
};

export default ProfileDataView;
